import { render, staticRenderFns } from "./FirstLoadScreen.vue?vue&type=template&id=6e226052&"
import script from "./FirstLoadScreen.vue?vue&type=script&lang=js&"
export * from "./FirstLoadScreen.vue?vue&type=script&lang=js&"
import style0 from "./FirstLoadScreen.vue?vue&type=style&index=0&id=6e226052&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports